module.exports = __webpack_public_path__ + "static/img/1.f91e034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/1.png
// module id = CggQ
// module chunks = 0